import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import CredibilityBar from '../components/CredibilityBar';
import OwnershipStrip from '../components/OwnershipStrip';
import Services from '../components/Services';
import CTABand from '../components/CTABand';
import WhyUs from '../components/WhyUs';
import Process from '../components/Process';
import Testimonials from '../components/Testimonials';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';

const Home = () => <div className="font-body bg-paper text-[#1c1c1c]"><Navbar/><Hero/><CredibilityBar/><OwnershipStrip/><CTABand/><Services/><WhyUs/><Process/><Testimonials/><FAQ/><Footer/></div>;
export default Home;
